export const safeSlug = (value) => {
  const text = String(value || "").trim();

  if (!text) return "";

  return text
    .toLowerCase()
    .replace(/['"]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9\u0600-\u06FF]+/gi, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};

export const productUrl = (productOrId, fallbackSlug = "") => {
  if (!productOrId) return "/products";

  if (typeof productOrId === "number" || typeof productOrId === "string") {
    const id = productOrId;
    const slug = safeSlug(fallbackSlug);

    return slug ? `/product/${id}/${slug}` : `/product/${id}`;
  }

  const id = productOrId._id || productOrId.id || productOrId.product_id;
  const slug = safeSlug(productOrId.slug || productOrId.name || productOrId.title || productOrId.product_name || fallbackSlug);

  if (!id) return "/products";

  return slug ? `/product/${id}/${slug}` : `/product/${id}`;
};
